

/**
 * Reusable Tab Navigation Component
 */
export function TabNavigation({ tabs, activeTab, onTabChange }) {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <tab.icon size={16} className="mr-2" />
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}

/**
 * Reusable Page Header Component
 */
export function PageHeader({ title, subtitle, actionButton }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
        <p className="mt-2 text-gray-600">{subtitle}</p>
      </div>
      {actionButton && (
        <div className="mt-4 sm:mt-0">
          {actionButton}
        </div>
      )}
    </div>
  );
}

/**
 * Reusable Tab Layout Component
 */
export function TabLayout({ 
  title, 
  subtitle, 
  tabs, 
  activeTab, 
  onTabChange, 
  actionButton,
  children 
}) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <PageHeader 
        title={title} 
        subtitle={subtitle} 
        actionButton={actionButton}
      />

      {/* Tabs */}
      <TabNavigation 
        tabs={tabs} 
        activeTab={activeTab} 
        onTabChange={onTabChange} 
      />

      {/* Tab Content */}
      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
}

/**
 * Reusable Content Card Component
 */
export function ContentCard({ title, children, className = "" }) {
  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-6 ${className}`}>
      {title && (
        <h2 className="text-xl font-semibold text-gray-900 mb-4">{title}</h2>
      )}
      {children}
    </div>
  );
}

/**
 * Reusable Summary Grid Component
 */
export function SummaryGrid({ items, title = "Summary" }) {
  return (
    <ContentCard title={title}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((item, index) => (
          <div key={index} className="text-center">
            <div className={`text-3xl font-bold ${item.color || 'text-gray-900'}`}>
              {item.value}
            </div>
            <p className="text-sm text-gray-600 mt-1">{item.label}</p>
          </div>
        ))}
      </div>
    </ContentCard>
  );
}
